import React from 'react'
import { OrgNodeData } from './NodeEditPanel'
import OrgTreeRow from './OrgTreeRow'

export interface OrgNodeWithChildren extends OrgNodeData {
  children: OrgNodeWithChildren[]
}

interface Handlers {
  canManage: boolean
  salesUnflaggedIds: Set<string>
  onAddChild: (parent: OrgNodeData) => void
  onEdit: (node: OrgNodeData) => void
  onMove: (node: OrgNodeData, direction: 'left' | 'right') => void
}

interface Props extends Handlers {
  roots: OrgNodeWithChildren[]
}

export function buildTree(nodes: OrgNodeData[]): OrgNodeWithChildren[] {
  const map = new Map<string, OrgNodeWithChildren>()
  const roots: OrgNodeWithChildren[] = []

  const sorted = [...nodes].sort((a, b) => a.position - b.position || a.name.localeCompare(b.name))

  for (const node of sorted) {
    map.set(node.id, { ...node, children: [] })
  }
  for (const node of sorted) {
    const treeNode = map.get(node.id)!
    if (node.parent_id && map.has(node.parent_id)) {
      map.get(node.parent_id)!.children.push(treeNode)
    } else {
      roots.push(treeNode)
    }
  }
  return roots
}

function Branch({ nodes, depth, ...handlers }: Handlers & { nodes: OrgNodeWithChildren[]; depth: number }) {
  return (
    <>
      {nodes.map((node, i) => (
        <div key={node.id}>
          <OrgTreeRow
            node={node}
            depth={depth}
            siblingIndex={i}
            siblingCount={nodes.length}
            {...handlers}
          />
          {node.children.length > 0 && (
            <div className="ml-[9px] border-l border-border pl-4">
              <Branch nodes={node.children} depth={depth + 1} {...handlers} />
            </div>
          )}
        </div>
      ))}
    </>
  )
}

export default function OrgTree({ roots, ...handlers }: Props) {
  if (roots.length === 0) {
    return <p className="text-sm text-muted-foreground px-2 py-4">No nodes yet.</p>
  }

  return (
    <div className="max-w-3xl">
      <Branch nodes={roots} depth={0} {...handlers} />
    </div>
  )
}
